// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBUadjDGZcEXJLjI9FLa8QvRGW23Cx6NoE",
  authDomain: "dropoff-mtaani.firebaseapp.com",
  projectId: "dropoff-mtaani",
  storageBucket: "dropoff-mtaani.firebasestorage.app",
  messagingSenderId: "260087149739",
  appId: "1:260087149739:web:de443a5136e537168eb3ee",
  measurementId: "G-0VTYKKWVFG"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export {app};
export {analytics}

